<template>
  <!-- 课程学习-已加入课程（新版 UI） -->
  <div class="course-learning-page">
    <!-- 顶部 Banner -->
    <div class="course-hero">
      <div class="hero-inner">
        <!-- 装饰性漂浮小球 -->
        <div class="float-orb" v-for="(orb, idx) in floatOrbs" :key="idx"
          :style="{ left: orb.left, top: orb.top, width: orb.size + 'px', height: orb.size + 'px', background: orb.color, '--float-duration': orb.duration, '--float-delay': orb.delay }">
        </div>

        <div class="hero-content">
          <div class="back-btn" @click="goBack">
            <i class="el-icon-arrow-left back-icon"></i>
            <span>返回</span>
          </div>
          <div class="hero-main">
            <div class="hero-left">
              <h1 class="course-title">{{ courseSemesterInfo.name || "" }}</h1>
              <div class="course-subtitle">
                <i class="el-icon-star-off collect-icon" :class="{ active: is_collect }" @click="toggleCollect"></i>
                <span class="collect-text">{{ is_collect ? "已收藏" : "收藏" }}</span>
              </div>
              <div class="course-tags">
                <span class="tag-list">
                  <span class="tag">实验课程</span>
                  <span class="dot">·</span>
                  <span class="tag">{{ courseSemesterInfo.course_type_config_info?.name }}</span>
                  <span class="dot">·</span>
                  <span class="tag">{{ courseSemesterInfo.subject_config_info?.name }}</span>
                </span>
              </div>
              <div class="course-meta">
                <div class="meta-item">
                  <el-image :src="leadingTeachersAvatar" class="meta-avatar" />
                  <span>
                    <div class="item-name">
                      主讲教师：
                      <div class="item-text" v-for="(item, index) in courseSemesterInfo.leading_user_info" :key="index">
                        {{ item }}
                        <span style="padding: 5px;"
                          v-if="index < courseSemesterInfo.leading_user_info.length - 1">,</span>
                      </div>
                    </div>
                  </span>
                </div>
                <div class="meta-item">
                  <el-image :src="collegeAvatar" class="meta-avatar" />
                  <span>所属学院：{{ courseSemesterInfo.college || "基础医学院" }}</span>
                </div>
              </div>
              <div class="semester-row">
                <span class="semester-label">开课 {{ courseInfo.nper || 0 }} 学期</span>
                <el-select v-model="courseSemesterSn" class="semester-select" placeholder="请选择" @change="switcCourse">
                  <el-option v-for="item in courseSemesters" :key="item.id" class="semester-option" :label="item.name"
                    :value="item.sn">
                    <span class="opt_name">{{ item.name }}</span>
                    <span class="opt_status">{{ item.status | statusFilter }}</span>
                  </el-option>
                </el-select>
              </div>
              <div class="join-row">
                <div class="join-btn" @click="enterCourse">
                  <div class="join-icon">{{ enterBtnText }}</div>
                  <div class="join-text">
                    <span class="open-time">
                      {{ courseSemesterInfo.start_time | dataformat }} ~ {{ courseSemesterInfo.end_time | dataformat }}
                      开课
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab 导航 -->
        <div class="tabs-bar-wrapper" :style="{ height: isTabFixed ? tabBarHeight + 'px' : 'auto' }">
          <div class="tabs-bar" ref="tabsBarRef" :class="{ fixed: isTabFixed }">
            <div class="tab-item" v-for="(item, index) in btlist" :key="index" :class="{ active: activebt === index }"
              @click.stop="btclick(index, item)">
              <div class="tab-line">
                <el-image class="tab-icon" :src="activebt === index ? item.icon2 : item.icon" />
                <div class="tab-name">{{ item.name }}</div>
              </div>
              <div class="active-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主体内容 -->
    <div class="course-body">
      <div class="main-content" ref="contentRef">
        <!-- Tab 内容 -->
        <div class="tab-panel">
          <courseintro v-if="activebt === 0" :content="courseSemesterInfo" :courseInfo="courseInfo"
            class="course-intro" />
          <teacherlist v-else-if="activebt === 1" :teachers="teacherList" />
          <div :class="[{ 'component_box': courseSemesterInfo.is_join === 0 && activebt !== 3 }]" v-else>
            <template v-if="courseSemesterInfo.is_join === 0 && activebt !== 3">
              <span>
                <i class="el-icon-warning empty-icon"></i>请先加入课程
              </span>
            </template>
            <component :is="componentId" ref="mycomponent" v-else></component>
          </div>
        </div>
      </div>

      <!-- 相关课程 -->
      <div class="right-side" v-if="resCourseList.length > 0">
        <div class="related-title">相关课程</div>
        <div class="related-list">
          <div v-for="(item, inx) in resCourseList" :key="inx" class="related-item" @click="to_detail(item)">
            <div class="related-img">
              <el-image :src="item.cover ? item.cover : image1" @error="e => { e.target.src = image1 }" />
            </div>
            <el-tooltip :content="item.name" placement="top" effect="light" v-if="item.flag">
              <div class="related-name">{{ item.name }}</div>
            </el-tooltip>
            <div class="related-name" v-else>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 页面 - 组件 */
import Courseoutline from "./components/courseoutline.vue"
import Virtualexperiment from "./components/virtualexperiment.vue"
import Homeworktest from "./components/homeworktest.vue"
import Courseinformation from "./components/courseinformation.vue"
import Discussion from "./components/discussion.vue"
import Courseintro from "./components/courseintro.vue"
import Teacherlist from "./components/teacherlist.vue"

/* 方法 - 接口 */
import {
  getcourseinfo,
  getCourseSemesterList,
  getCourseSemesterInfo,
  getRecCourseSemesterList,
  joincourse,
  cancelJoinCourse
} from "@/api/course"
import { getcourseteacherlist } from "@/api/courseteacher"
import dayjs from "dayjs"
import { getToken } from "@/utils/auth"

const statusMap = {
  0: "未开始",
  1: "进行中",
  2: "已结束",
}

export default {
  name: "courselearning",
  components: {
    Courseoutline,
    Virtualexperiment,
    Homeworktest,
    Courseinformation,
    Discussion,
    Courseintro,
    Teacherlist,
  },
  inject: ["reload"],
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm")
    },
    statusFilter(status) {
      return statusMap[status]
    },
  },
  data() {
    return {
      is_collect: false,
      collect_count: 0,
      courseSn: "",
      courseInfo: {},
      courseKey: "",
      courseSemesterId: "",
      courseSemesterSn: "",
      courseSemesterInfo: {},
      courseSemesters: [],
      componentId: "Courseintro",

      // 装饰性漂浮小球数据（全页面平铺 35 个）
      floatOrbs: [
        // 顶部区域
        { left: '8%', top: '5%', size: 10, color: 'rgba(139, 124, 255, 0.6)', delay: '0s', duration: '4s' },
        { left: '22%', top: '8%', size: 8, color: 'rgba(106, 90, 249, 0.5)', delay: '0.3s', duration: '3.5s' },
        { left: '35%', top: '3%', size: 12, color: 'rgba(139, 124, 255, 0.65)', delay: '0.6s', duration: '4.5s' },
        { left: '50%', top: '6%', size: 9, color: 'rgba(106, 90, 249, 0.55)', delay: '0.9s', duration: '3.8s' },
        { left: '68%', top: '4%', size: 11, color: 'rgba(139, 124, 255, 0.6)', delay: '0.2s', duration: '4.2s' },
        { left: '82%', top: '7%', size: 10, color: 'rgba(106, 90, 249, 0.5)', delay: '1.1s', duration: '3.6s' },
        { left: '92%', top: '12%', size: 13, color: 'rgba(139, 124, 255, 0.7)', delay: '0.4s', duration: '4.4s' },

        // 上部区域
        { left: '5%', top: '18%', size: 9, color: 'rgba(106, 90, 249, 0.5)', delay: '0.7s', duration: '3.4s' },
        { left: '18%', top: '22%', size: 11, color: 'rgba(139, 124, 255, 0.6)', delay: '1.2s', duration: '4.1s' },
        { left: '30%', top: '25%', size: 14, color: 'rgba(106, 90, 249, 0.65)', delay: '0.1s', duration: '4.7s' },
        { left: '44%', top: '30%', size: 18, color: 'rgba(139, 124, 255, 0.8)', delay: '0.5s', duration: '5s' },
        { left: '58%', top: '28%', size: 13, color: 'rgba(106, 90, 249, 0.7)', delay: '0.8s', duration: '3.9s' },
        { left: '72%', top: '32%', size: 15, color: 'rgba(139, 124, 255, 0.75)', delay: '1.3s', duration: '4.3s' },
        { left: '86%', top: '25%', size: 10, color: 'rgba(106, 90, 249, 0.55)', delay: '0.3s', duration: '3.5s' },

        // 中部区域
        { left: '3%', top: '40%', size: 8, color: 'rgba(139, 124, 255, 0.5)', delay: '0.9s', duration: '3.7s' },
        { left: '15%', top: '45%', size: 12, color: 'rgba(106, 90, 249, 0.6)', delay: '1.4s', duration: '4s' },
        { left: '28%', top: '50%', size: 10, color: 'rgba(139, 124, 255, 0.55)', delay: '0.2s', duration: '3.8s' },
        { left: '42%', top: '48%', size: 14, color: 'rgba(106, 90, 249, 0.65)', delay: '0.6s', duration: '4.2s' },
        { left: '55%', top: '52%', size: 16, color: 'rgba(139, 124, 255, 0.7)', delay: '1.0s', duration: '4.6s' },
        { left: '68%', top: '55%', size: 13, color: 'rgba(106, 90, 249, 0.6)', delay: '0.4s', duration: '3.9s' },
        { left: '80%', top: '48%', size: 11, color: 'rgba(139, 124, 255, 0.55)', delay: '1.2s', duration: '4.1s' },
        { left: '94%', top: '52%', size: 9, color: 'rgba(106, 90, 249, 0.5)', delay: '0.7s', duration: '3.6s' },

        // 下部区域
        { left: '6%', top: '65%', size: 10, color: 'rgba(139, 124, 255, 0.55)', delay: '1.5s', duration: '3.3s' },
        { left: '20%', top: '70%', size: 8, color: 'rgba(106, 90, 249, 0.5)', delay: '0.5s', duration: '3.7s' },
        { left: '34%', top: '75%', size: 12, color: 'rgba(139, 124, 255, 0.65)', delay: '1.1s', duration: '4.4s' },
        { left: '48%', top: '72%', size: 15, color: 'rgba(106, 90, 249, 0.7)', delay: '0.3s', duration: '4.8s' },
        { left: '62%', top: '78%', size: 11, color: 'rgba(139, 124, 255, 0.6)', delay: '0.8s', duration: '4s' },
        { left: '76%', top: '75%', size: 14, color: 'rgba(106, 90, 249, 0.65)', delay: '1.4s', duration: '3.9s' },
        { left: '88%', top: '70%', size: 10, color: 'rgba(139, 124, 255, 0.55)', delay: '0.1s', duration: '3.5s' },

        // 底部区域
        { left: '10%', top: '88%', size: 9, color: 'rgba(106, 90, 249, 0.5)', delay: '0.9s', duration: '3.2s' },
        { left: '25%', top: '92%', size: 11, color: 'rgba(139, 124, 255, 0.6)', delay: '1.3s', duration: '3.8s' },
        { left: '40%', top: '90%', size: 13, color: 'rgba(106, 90, 249, 0.7)', delay: '0.6s', duration: '4.3s' },
        { left: '55%', top: '93%', size: 10, color: 'rgba(139, 124, 255, 0.55)', delay: '1.0s', duration: '3.6s' },
        { left: '70%', top: '88%', size: 15, color: 'rgba(106, 90, 249, 0.75)', delay: '0.4s', duration: '4.5s' },
        { left: '85%', top: '92%', size: 12, color: 'rgba(139, 124, 255, 0.6)', delay: '1.2s', duration: '4s' },
      ],

      teachteam: "",
      teacherList: [],
      teacherPage: 1,
      teacherPerPage: 100,
      teacherHasMore: false,
      teacherLoading: false,
      image1: require("@/assets/defaultImage.png"),

      btlist: [
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_class.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_class.png"),
          name: "课程介绍",
          component: "Courseintro",
        },
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_teachteam.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_teachteam.png"),
          name: "教师团队",
          component: "Teacherlist",
        },
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_AR.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_AR.png"),
          name: "虚拟仿真实验",
          component: "Virtualexperiment",
        },
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_classview.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_classview.png"),
          name: "课程大纲",
          component: "Courseoutline",
        },
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_test.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_test.png"),
          name: "作业考试",
          component: "Homeworktest",
        },
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_material.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_material.png"),
          name: "课程资料",
          component: "Courseinformation",
        },
        {
          icon: require("@/assets/course/UIout/homepage/home_ico_QA.png"),
          icon2: require("@/assets/course/UIout/homepage/home_ico_QA.png"),
          name: "互动问答",
          component: "Discussion",
        },
      ],
      activebt: 0,
      resCourseList: [],
      isTabFixed: false,
      tabBarHeight: 0,
      tabBarOffsetTop: 0,
      leadingTeachersAvatar: require("@/assets/course/UIout/homepage/home_ico_teacher.png"),
      collegeAvatar: require("@/assets/course/UIout/homepage/home_ico_school.png"),
    }
  },
  computed: {
    leadingTeachers() {
      if (this.courseSemesterInfo.leading_user_info && this.courseSemesterInfo.leading_user_info.length > 0) {
        return this.courseSemesterInfo.leading_user_info.join("、")
      }
      return this.teachteam || "暂无"
    },
    enterBtnText() {
      const status = this.courseSemesterInfo?.is_join
      if (status == 0) return "加入课程"
      // if (status == 2) return "退出课程"
      if (status == 1) return "退出课程"
      return
    },
  },
  created() {
    this.activebt = 0
    this.courseSn = decodeURIComponent(this.$route.query.course_sn)
    console.log(this.courseSn, "课程编号")
    console.log(getToken(), "token")

    if (getToken()) {
      this.initdata()
    } else {
      this.$confirm("请先登录!", "登录提示", {
        confirmButtonText: "去登录",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "myClass",
      }).then(() => {
        this.$router.push({
          path: "/login",
        })
        localStorage.setItem("login_path", "/home/wisdompracticeteaching/courselearning?course_sn=" + this.courseSn + "&course_semester_sn=" + this.courseSemesterSn)
      }).catch(() => { })
    }
  },
  mounted() {
    this.initTabBarSticky()
  },
  beforeDestroy() {
    this.destroyTabBarSticky()
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    enterCourse() {
      if (this.courseSemesterInfo?.course_status == 0) {
        this.$message.info("课程尚未开课")
        return
      }
      if (this.courseSemesterInfo?.is_join === 1) {
        this.setCancelJoin()
      } else {
        this.setCourseJoin()
      }
      // 默认跳转到课程大纲 tab
      this.btclick(3, this.btlist[3])
    },
    toggleCollect() {
      // 收藏功能预留，如需接入可调用 collectCourse 接口
      this.is_collect = !this.is_collect
      this.$message.success(this.is_collect ? "收藏成功" : "取消收藏")
    },
    handleError(e) {
      e.target.src = this.image1
    },
    initdata() {
      if (this.$route.query.course_semester_sn) {
        this.courseSemesterSn = decodeURIComponent(this.$route.query.course_semester_sn)
        this.setCourseSemester()
      } else {
        this.getcourseinfo()
        // this.getCourseSemesterList()
      }
    },
    getcourseinfo() {
      const params = { course_sn: this.courseSn }
      getcourseinfo(params)
        .then((res) => {
          if (res.code === 0 && res.data) {
            console.log("res2026", res.data)
            this.courseInfo = res.data.course_info
            this.courseSemesterId = this.courseInfo.newest_course_semester_id
            this.courseSemesterInfo = res.data.info || {}
            this.courseSemesterSn = this.courseSemesterInfo.course_semester_sn || ""
            this.courseKey = this.courseSemesterSn || ""
            this.is_collect = res.data.info?.is_collect
            this.collect_count = res.data.info?.collect_count || 0
            this.centerPoint = {
              address: res.data.info?.address?.address,
              lng: res.data.info?.address?.longitude,
              lat: res.data.info?.address?.latitude,
            }
            console.log(this.courseSemesterInfo, this.courseKey, '课程学期信息11')

            // this.$refs.mycomponent.initdata(this.courseSemesterInfo, this.courseKey)
            this.getCourseSemesterList()
            this.getRecCourseList()
            this.getteacherlist()
          } else if (res.code === 3) {
            this.$router.push({
              path: "/home/wisdompracticeteaching/mainpage",
            })
          }
        })
        .catch(() => { })
    },
    getCourseSemesterList() {
      const params = {
        course_sn: this.courseSn,
        page: 1,
        per_page: 100,
      }
      getCourseSemesterList(params).then((res) => {
        if (res.code === 0 && res.data) {
          console.log("res", res.data)
          this.courseSemesters = res.data.map((item) => {
            return {
              id: item.course_semester_id,
              sn: item.course_semester_sn,
              name: item.start_year + "-" + item.end_year + " 第" + item.semester_nper + "学期",
              status: item.time_status,
            }
          })
        }
      })
    },
    switcCourse(e) {
      this.courseSemesterSn = e
      this.setCourseSemester()
    },
    setCourseSemester() {
      const params = { course_semester_sn: this.courseSemesterSn }
      getCourseSemesterInfo(params).then((res) => {
        if (res.code === 0 && res.data) {
          if (Number(res.data.info.is_join) === 1) {
            this.courseInfo = res.data.course_info
            this.courseSemesterId = this.courseInfo.newest_course_semester_id
            this.courseSemesterInfo = res.data.info || {}
            this.courseSemesterSn = this.courseSemesterInfo.course_semester_sn || ""
            this.courseKey = this.courseSemesterSn || ""
            this.is_collect = res.data.info?.is_collect
            this.collect_count = res.data.info?.collect_count || 0
            this.centerPoint = {
              address: res.data.info?.address?.address,
              lng: res.data.info?.address?.longitude,
              lat: res.data.info?.address?.latitude,
            }
            console.log(this.courseSemesterInfo, this.courseKey, '课程学期信息')
            // this.$refs.mycomponent.initdata(this.courseSemesterInfo, this.courseKey)
            this.getCourseSemesterList()
            this.getRecCourseList()
            this.getteacherlist()
          } else {
            this.$router.push({
              path: "/home/wisdompracticeteaching/coursedetails",
              query: {
                course_sn: this.courseSn,
                course_semester_sn: this.courseSemesterSn,
              },
            })
          }
        }
      })
    },
    getRecCourseList() {
      this.resCourseList = []
      const params = {
        course_semester_sn: this.courseSemesterSn,
        page: 1,
        per_page: 100,
      }
      getRecCourseSemesterList(params).then((res) => {
        if (res.code === 0) {
          res.data.data.map((item) => {
            if (item.name.length > 14) {
              item.flag = true
            }
          })
          this.resCourseList = res.data.data
        }
      })
    },
    initTabBarSticky() {
      this.$nextTick(() => {
        const tabsBar = this.$refs.tabsBarRef
        if (!tabsBar) return
        this.tabBarHeight = tabsBar.offsetHeight
        // 记录导航栏在文档中的原始垂直位置（相对文档顶部，不受 fixed 影响）
        this.tabBarOffsetTop = tabsBar.getBoundingClientRect().top + window.pageYOffset
        this.handleTabScroll = () => {
          // 用滚动距离与原始位置比较，向上滑过即悬浮，向下滑回即还原
          this.isTabFixed = window.pageYOffset >= this.tabBarOffsetTop
        }
        window.addEventListener("scroll", this.handleTabScroll, { passive: true })
      })
    },
    destroyTabBarSticky() {
      if (this.handleTabScroll) {
        window.removeEventListener("scroll", this.handleTabScroll)
      }
    },
    btclick(name, component) {
      this.activebt = name
      this.componentId = component.component
      this.$nextTick(() => {
        if (this.$refs.mycomponent && this.$refs.mycomponent.initdata) {
          this.$refs.mycomponent.initdata(this.courseSemesterInfo, this.courseKey)
        }
        // 切换到对应内容后，自动平滑滚动定位到内容区，无需手动滑动
        this.scrollToContent()
      })
    },
    scrollToContent() {
      const content = this.$refs.contentRef
      if (!content) return
      // 预留悬浮导航栏高度，避免内容被遮挡
      const offset = (this.tabBarHeight || 80) + 75
      const top = content.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({ top, behavior: "smooth" })
    },
    getteacherlist() {
      this.teacherPage = 1
      this.teacherList = []
      this.teacherHasMore = false
      const params = {
        course_semester_sn: this.courseSemesterSn,
        page: this.teacherPage,
        per_page: this.teacherPerPage,
      }
      getcourseteacherlist(params)
        .then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            this.teacherList = response.data.data.sort((a, b) => {
              if (a.is_leading === b.is_leading) {
                return 0
              }
              return a.is_leading ? -1 : 1
            }) // 根据is_leading排序
            // this.teacherList.sort((a, b) => {
            //   if (a.is_leading === b.is_leading) {
            //     return 0
            //   }
            //   return a.is_leading ? -1 : 1
            // })
            const arr = this.teacherList.map((el) => el.name)
            this.teachteam = arr.join("、")
            const total = response.data.total || 0
            this.teacherHasMore = this.teacherList.length < total
          }
        })
        .catch(() => { })
    },
    to_detail(item) {
      // if (item.is_join == 1) {
      this.$router.push({
        path: "/home/wisdompracticeteaching/courselearning",
        query: {
          course_semester_sn: item.course_semester_sn,
        },
      })
      this.reload()
      // } else {
      //   this.$router.push({
      //     path: "/home/wisdompracticeteaching/coursedetails",
      //     query: {
      //       course_semester_sn: item.course_semester_sn,
      //     },
      //   })
      // }
    },
    setCourseJoin() {
      let params = {
        course_semester_sn: this.courseSemesterSn,
      }
      joincourse(params).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: "恭喜您，加入课程成功!",
            type: "success",
          })
          this.reload()
        }
      }).catch(() => { })
    },
    setCancelJoin() {
      let params = {
        course_semester_sn: this.courseSemesterSn,
      }
      cancelJoinCourse(params).then((res) => {
        if (res.code === 0) {
          this.$message.success("退出课程成功!")
          this.reload()
        }
      }).catch(() => { })
    },
  },
}
</script>

<style scoped lang="scss">
.course-learning-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 60px;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}

// 小球漂浮动画（默认暂停，hover 时播放）
@keyframes orbFloat {
  0% {
    transform: translate(0, 0) scale(1);
  }

  25% {
    transform: translate(6px, -10px) scale(1.05);
  }

  50% {
    transform: translate(-4px, -18px) scale(1.1);
  }

  75% {
    transform: translate(8px, -8px) scale(1.05);
  }

  100% {
    transform: translate(0, 0) scale(1);
  }
}

// 小球脉冲发光动画
@keyframes orbPulse {

  0%,
  100% {
    box-shadow: 0 0 8px rgba(139, 124, 255, 0.5), 0 0 16px rgba(106, 90, 249, 0.3);
  }

  50% {
    box-shadow: 0 0 16px rgba(139, 124, 255, 0.8), 0 0 32px rgba(106, 90, 249, 0.5);
  }
}

/* 顶部 Banner */
.course-hero {
  position: relative;
  width: 100%;
  background: url(~@/assets/course/UIout/homepage/home_bg_color.png) no-repeat center center;
  background-size: cover;
  overflow: hidden;
  margin-bottom: 40px;

  .hero-inner {
    position: relative;
    width: 100%;
    min-height: 96vh;
    background: url(~@/assets/course/UIout/homepage/home_bg_common.png) no-repeat center top;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    background-position: bottom;

    // 装饰性漂浮小球
    .float-orb {
      position: absolute;
      border-radius: 50%;
      pointer-events: none;
      opacity: 0.7;
      box-shadow: 0 0 6px rgba(139, 124, 255, 0.35), 0 0 12px rgba(106, 90, 249, 0.15);
      animation-name: orbFloat, orbPulse;
      animation-timing-function: linear, ease-in-out;
      animation-iteration-count: infinite, infinite;
      animation-duration: var(--float-duration, 4s), 3s;
      animation-play-state: paused, paused;
      animation-delay: var(--float-delay, 0s), 0s;
      z-index: 2;
      transition: opacity 0.3s, box-shadow 0.3s;

      &:hover {
        transform: scale(1.8);
        opacity: 1 !important;
        box-shadow: 0 0 20px rgba(139, 124, 255, 0.9), 0 0 40px rgba(106, 90, 249, 0.6) !important;
        cursor: pointer;
        animation-play-state: paused, paused;
      }
    }

    // 父容器 hover 时小球动起来
    &:hover .float-orb {
      pointer-events: auto;
      opacity: 0.9;
      animation-play-state: running, running;
      box-shadow: 0 0 10px rgba(139, 124, 255, 0.6), 0 0 20px rgba(106, 90, 249, 0.3);
    }

    .hero-content {
      width: 100%;
      max-width: 1640px;
      margin: 0 auto;
      padding: 20px 40px 0;
      box-sizing: border-box;

      .back-btn {
        width: 90px;
        background: #fff;
        // display: inline-flex;
        // align-items: center;
        color: #555555;
        font-size: 14px;
        cursor: pointer;
        // margin-bottom: 24px;
        transition: color 0.3s; // 添加过渡效果
        padding: 5px;
        border-radius: 30px;
        text-align: center;

        .back-icon {
          margin-right: 4px;
          width: 30px;
          height: 30px;
          background: #8b7cff;
          border-radius: 50%;
          line-height: 30px;
          text-align: center;
          color: #fff;
          font-weight: bold;
        }

        i {
          margin-right: 4px;
        }

        &:hover {
          color: #8b7cff;
        }
      }

      .hero-main {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 18vh;

        .hero-left {
          flex: 1;
          max-width: 760px;
          color: #333333;

          .course-title {
            font-size: 34px;
            font-weight: 700;
            line-height: 1.4;
            margin: 0 0 14px;
            color: #333333;
          }

          .course-subtitle {
            display: flex;
            align-items: center;
            margin-bottom: 4vh;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 3vh;

            .collect-text {
              font-weight: 500;
              font-size: 18px;
              color: #aeaeb2;
              line-height: 26px;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }

            .collect-icon {
              font-size: 38px;
              color: #b0a8d9;
              cursor: pointer;
              transition: color 0.3s;

              &.active,
              &:hover {
                color: #ffd700;
              }
            }

            .tag-list {
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #666666;

              .tag {
                display: inline-block;
                padding: 2px 0;
              }

              .dot {
                margin: 0 8px;
                opacity: 0.5;
              }
            }
          }

          .course-tags {
            font-weight: 500;
            font-size: 20px;
            color: #555555;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 6vh;
          }

          .course-meta {
            display: flex;
            flex-wrap: wrap;
            gap: clamp(20px, 4vw, 70px);
            margin-bottom: 10vh;

            .meta-item {
              height: 58px;
              display: inline-flex;
              align-items: center;
              padding: 8px 25px;
              background: rgba(255, 255, 255, 0.6);
              box-shadow: 0px 4px 9px 2px rgba(209, 202, 252, 0.4);
              border-radius: 75px 75px 75px 75px; // 透明度0.6
              font-weight: 500;
              font-size: 20px;
              color: #555555;
              text-align: left;
              font-style: normal;
              text-transform: none;
              color: #555555;
              backdrop-filter: blur(4px);
              box-shadow: 0 2px 8px rgba(106, 90, 249, 0.06);

              .meta-avatar {
                width: 40px;
                height: 40px;
                margin-right: 8px;
                font-size: 16px;
                background: #6a5af9;
                border-radius: 50%;
                padding: 10px;
                box-shadow: 0px 1px 2px 1px rgba(209, 202, 252, 0.4);
                overflow: hidden;

                ::v-deep img {
                  object-fit: cover;
                }
              }

              .item-name {
                display: flex;
              }
            }
          }

          .semester-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
            margin-bottom: 5vh;

            .semester-label {
              font-weight: 500;
              font-size: 20px;
              color: #333333;
              letter-spacing: 4px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              margin-right: 20px;
            }

            ::v-deep .semester-select {
              // 深度选择器
              width: clamp(220px, 28vw, 320px);

              .el-input__inner {
                background: rgba(255, 255, 255, 0.8);
                border-radius: 75px 75px 75px 75px;
                border: 1px solid rgba(170, 170, 170, 0.5);
                color: #333333;
                border-radius: 20px;
                height: 48px;

                &::placeholder {
                  color: #999999;
                }
              }

              .el-input__suffix {
                .el-input__icon {
                  color: #6a5af9;
                }
              }
            }
          }

          .join-row {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 14px;
            margin-bottom: 5vh;

            .join-btn {
              min-width: 180px;
              height: 46px;
              padding: 15px 32px;
              background: linear-gradient(135deg, #8b7cff 0%, #6a5af9 100%);
              border: none;
              border-radius: 50px;
              font-size: 16px;
              font-weight: 600;
              color: #ffffff;
              cursor: pointer;
              box-shadow: 0 6px 18px rgba(106, 90, 249, 0.35);
              transition: all 0.3s;
              text-align: center;

              &:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 22px rgba(106, 90, 249, 0.45);
              }

              .join-icon {
                font-weight: bold;
                font-size: 20px;
                color: #ffffff;
                text-align: center;
                font-style: normal;
                text-transform: none;
                // padding-bottom: 10px;
              }

              .join-text {
                font-weight: 500;
                font-size: 16px;
                color: #ffffff;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }

            // .open-time {
            //   font-size: 13px;
            //   color: #888888;
            // }
          }
        }
      }
    }

    .tabs-bar-wrapper {
      width: 100%;
    }

    .tabs-bar {
      width: 100%;
      max-width: 1800px;
      margin: 0 auto 40px;
      padding: 8px clamp(8px, 1vw, 24px);
      min-height: 64px;
      height: auto;
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0px 4px 9px 2px rgba(209, 202, 252, 0.4);
      border-radius: 75px 75px 75px 75px;
      // border-radius: 30px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      gap: clamp(4px, 0.5vw, 12px);
      overflow-x: auto;

      &.fixed {
        position: fixed;
        top: 80px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100;
        margin: 0 auto;
        width: calc(100% - 80px);
        max-width: 1800px;
        // padding: 8px 40px;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      }

      &::-webkit-scrollbar {
        height: 0;
      }

      .tab-item {
        // display: flex;
        // align-items: center;
        // justify-content: center;
        // flex: 1;
        min-width: 0;
        padding: clamp(8px, 1vh, 12px) clamp(10px, 1vw, 38px);
        border-radius: 24px;
        cursor: pointer;
        user-select: none;
        transition: all 0.3s;
        color: #666666;
        background: transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        // padding: 0px 40px;

        .tab-icon {
          // width: 38px;
          // height: 31px;
          width: clamp(20px, 2vw, 150px);
          height: clamp(20px, 2vw, 150px);
          // margin-right: clamp(4px, 0.6vw, 10px);
          flex-shrink: 0;
        }

        .tab-name {
          font-weight: bold;
          font-size: clamp(13px, 1.15vw, 20px);
          color: #333333;
          text-align: center;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .tab-line {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .active-line {
          width: 0;
          height: 0;
          // margin-top: 8px;
          border-bottom: 3px solid transparent;
          border-radius: 3px;
          transition: width 0.3s;
        }

        &.active .active-line {
          width: 100%;
          border-bottom-color: #8070fa;
        }
      }
    }
  }
}

/* 主体内容 */
.course-body {
  max-width: 1750px;
  margin: clamp(16px, 1.5vw, 24px) auto 0;
  padding: 0 clamp(16px, 2.5vw, 40px);
  display: flex;
  gap: clamp(16px, 1.5vw, 24px);

  .main-content {
    flex: 1;
    min-width: 0;
    border-radius: 16px;
    // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    overflow: hidden;


    .tab-panel {


      .component_box {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        color: #666666;

        .empty-icon {
          margin-right: 6px;
        }
      }
    }
  }

  .right-side {
    width: clamp(260px, 22vw, 300px);
    flex-shrink: 0;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    padding: clamp(16px, 1.5vw, 20px);
    box-sizing: border-box;
    background: url(~@/assets/course/UIout/courseintro/courseintro_decor_02.png) no-repeat;
    background-position: right bottom;

    .related-title {
      font-size: 16px;
      font-weight: 600;
      color: #222222;
      margin-bottom: 16px;
      padding-left: 8px;
      border-left: 4px solid #6a5af9;
    }

    .related-list {
      .related-item {
        cursor: pointer;
        margin-bottom: 16px;
        background-color: #fff;
        border-radius: 8px;

        &:hover {
          .related-name {
            color: #6a5af9;
          }
        }

        .related-img {
          width: 100%;
          height: 146px;
          border-radius: 8px 8px 0 0;
          overflow: hidden;
          // margin-bottom: 8px;

          ::v-deep .el-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .related-name {
          font-size: 14px;
          color: #555555;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          transition: color 0.3s;
          padding: 8px 10px;
        }
      }
    }
  }
}

/* 下拉选项 */
.semester-option {
  .opt_name {
    color: #333;
    font-size: 14px;
    line-height: 30px;
    float: left;
  }

  .opt_status {
    color: #6a5af9;
    font-size: 12px;
    line-height: 22px;
    padding: 0 10px;
    background: #f3f0ff;
    border-radius: 12px;
    float: right;
    margin-left: 20px;
    margin-top: 4px;
  }
}

/* 响应式 */
@media only screen and (max-width: 1440px) {
  .course-hero .hero-inner .tabs-bar.fixed {
    top: 70px;
    width: calc(100% - 60px);
  }
}

@media only screen and (max-width: 1200px) {
  .course-hero .hero-inner {
    min-height: auto;
    padding-bottom: 40px;

    .hero-content {
      padding: 20px 30px 0;

      .hero-main {
        margin-top: 80px;

        .hero-left {
          .course-title {
            font-size: 28px;
          }

          .course-meta {
            margin-bottom: 60px;
          }
        }
      }
    }

    .tabs-bar {
      margin: 0 30px 30px;

      &.fixed {
        top: 70px;
        width: calc(100% - 60px);
      }

      .tab-name {
        font-size: 14px;
      }
    }
  }

  .stats-section .stats-card {
    flex-direction: column;

    .stat-left {
      flex: 1;
      width: 100%;
      flex-direction: row;

      .stat-large {
        min-height: 180px;
        aspect-ratio: auto;
      }
    }

    .stat-right {
      width: 100%;
    }
  }

  .course-body {
    flex-direction: column;

    .right-side {
      width: 100%;
    }
  }
}

@media only screen and (max-width: 768px) {
  .course-hero .hero-inner {
    padding-bottom: 30px;

    .float-orb {
      display: none;
    }

    .hero-content {
      padding: 16px 20px 0;

      .hero-main {
        margin-top: 50px;

        .hero-left {
          .course-title {
            font-size: 22px;
          }

          .course-subtitle {
            margin-bottom: 20px;
          }

          .course-tags {
            font-size: 15px;
            margin-bottom: 30px;
          }

          .course-meta {
            gap: 10px;
            margin-bottom: 40px;

            .meta-item {
              height: auto;
              padding: 6px 12px;
              font-size: 12px;

              .meta-avatar {
                width: 28px;
                height: 28px;
              }
            }
          }

          .semester-row {
            flex-wrap: wrap;

            .semester-label {
              font-size: 15px;
              letter-spacing: 2px;
            }
          }
        }
      }
    }

    .tabs-bar {
      margin: 0 20px 20px;
      padding: 6px;
      border-radius: 20px;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      &.fixed {
        top: 60px;
        width: calc(100% - 40px);
      }

      .tab-item {
        flex-shrink: 0;
        min-width: auto;
        padding: 8px 12px;

        .tab-icon {
          width: 18px;
          height: 18px;
          margin-right: 4px;
        }

        .tab-name {
          font-size: 12px;
          white-space: nowrap;
        }
      }
    }
  }

  .stats-section {
    padding: 0 20px;

    &.fixed {
      margin-top: 80px;
    }

    .stats-card {
      flex-direction: column;
      padding: 16px;
      gap: 12px;

      .stat-left {
        flex-direction: row;

        .stat-large {
          min-height: 130px;
          padding: 16px;

          .large-info {
            .large-value {
              font-size: 24px;
            }
          }
        }
      }

      .stat-right {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;

        .stat-small {
          min-height: 100px;
          padding: 0 14px;

          .small-info {
            .small-value {
              font-size: 18px;
            }
          }
        }
      }
    }
  }

  .course-body {
    padding: 0 20px;
  }
}

@media only screen and (max-width: 480px) {
  .course-hero .hero-inner {
    .hero-content .hero-main .hero-left .course-title {
      font-size: 20px;
    }

    .tabs-bar {
      padding: 4px;
      gap: 2px;

      .tab-item {
        padding: 6px 4px;

        .tab-icon {
          width: 16px;
          height: 16px;
        }

        .tab-name {
          font-size: 11px;
        }
      }
    }
  }

  .stats-section .stats-card {
    .stat-left {
      flex-direction: column;

      .stat-large {
        min-height: 150px;
      }
    }

    .stat-right {
      grid-template-columns: 1fr;

      .stat-small {
        min-height: 110px;
      }
    }
  }
}
</style>
